import { createContext, useContext, useState, useCallback } from "react";

const QuoteModalContext = createContext(null);

export function QuoteModalProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [prefill, setPrefill] = useState({});

  const openModal = useCallback((opts = {}) => {
    setPrefill(opts);
    setOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setOpen(false);
  }, []);

  const setOpenChange = useCallback((value) => {
    setOpen(value);
    if (!value) setPrefill({});
  }, []);

  return (
    <QuoteModalContext.Provider
      value={{ open, prefill, openModal, closeModal, setOpenChange }}
    >
      {children}
    </QuoteModalContext.Provider>
  );
}

export function useQuoteModal() {
  const ctx = useContext(QuoteModalContext);
  if (!ctx)
    throw new Error("useQuoteModal must be used within QuoteModalProvider");
  return ctx;
}
